(function ($) {
	'use strict';

	$(function () {
		const cardActiveClass = 'opener-card--active';
		const hiddenActiveClass = 'opener-card__hidden--active';

		document.querySelectorAll('.js-opener-card').forEach(card => {
			const button = card.querySelector('.js-opener-card-opener');
			const hiddenContent = card.querySelector('.js-opener-card-hidden');

			if (!hiddenContent) {
				const buttonContent = button.innerHTML;
				const buttonParent = button.parentNode;
				const buttonReplaceDiv = document.createElement('div');

				buttonParent.removeChild(button);
				buttonReplaceDiv.classList.add('opener-card__opener', 'opener-card__opener--inert');
				buttonReplaceDiv.innerHTML = buttonContent;
				buttonParent.appendChild(buttonReplaceDiv);

				return;
			}

			const closeButton = card.querySelector('.js-opener-card-close');

			button.addEventListener('click', function (e) {
				e.preventDefault();
				hiddenContent.classList.toggle(hiddenActiveClass);
				card.classList.toggle(cardActiveClass);
				button.setAttribute('aria-expanded', hiddenContent.classList.contains(hiddenActiveClass));
			});

			closeButton.addEventListener('click', function (e) {
				e.preventDefault();
				hiddenContent.classList.remove(hiddenActiveClass);
				card.classList.remove(cardActiveClass);
				button.setAttribute('aria-expanded', false);
			});

			document.addEventListener('click', function (event) {
				if (!card.contains(event.target)) {
					hiddenContent.classList.remove(hiddenActiveClass);
					card.classList.remove(cardActiveClass);
					button.setAttribute('aria-expanded', false);
				}
			});
		});
	});
})(jQuery, document, window);
